import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPublicShop = loadable(() => import(/* webpackChunkName: "content/publicstationeryshop" */ './PublicShop'), 'PublicShop');
